// extracted by mini-css-extract-plugin
export default {"icon":"Edit_icon__n4dIW"};